<template>
  <b-row class="w-100 px-0 mb-2">

    <b-col :cols="inputSizeDefault" :md="inputSizeDefault" v-if="communityShowDefault">
      <b-form-group label-for="community">
        <template slot="label">
          <slot name="community-label"><strong>Comunidad<template v-if="!!communityRequired">
            *</template></strong></slot>
        </template>
        <NewLocationCommunitySelector :onFieldClear="onFieldClear" :communitySelected="community"
                                      :onSelected="onSelectedCommunity" :initialCommunity="initialCommunity" :disabled=false>

        </NewLocationCommunitySelector>
      </b-form-group>
    </b-col>
    <b-col :cols="inputSizeDefault" :md="inputSizeDefault">
      <b-form-group label-for="province">
        <template slot="label">
          <slot name="province-label"><strong>Provincia<template v-if="!!provinceRequired">
            *</template></strong></slot>
        </template>

        <NewLocationProvinceSelector :communityShowDefault="this.communityShowDefault"
                                     :onFieldClear="onFieldClear" :fieldClearArray="fieldClearArray" :provinceSelected="province"
                                     :communitySelected="community" :initialProvince="initialProvince" :onSelected="onSelectedProvince"
                                     :disabled="((this.community !== undefined && this.community !== null) && this.communityShowDefault == true) || (this.communityShowDefault == false) ? false : true">

        </NewLocationProvinceSelector>

      </b-form-group>
    </b-col>

    <b-col :cols="inputSizeDefault" :md="inputSizeDefault">
      <b-form-group label-for="town">
        <template slot="label">
          <slot name="town-label"><strong>Municipio<template v-if="!!townRequired">
            *</template></strong></slot>
        </template>

        <NewLocationTownSelector :onFieldClear="onFieldClear" :fieldClearArray="fieldClearArray"
                                 :townSelected="town" :provinceSelected="province" :onSelected="onSelectedTown"
                                 :initialTown="initialTown"
                                 :disabled="(this.province !== null && this.province !== undefined) ? false : true">

        </NewLocationTownSelector>

      </b-form-group>
    </b-col>
    <b-col :cols="inputSizeDefault" :md="inputSizeDefault">
      <b-form-group label-for="postalCode">
        <template slot="label">
          <slot name="town-label"><strong>Código Postal<template v-if="!!postalCodeRequired">
            *</template></strong></slot>
        </template>

        <NewLocationPostalCodeSelector :onFieldClear="onFieldClear" :fieldClearArray="fieldClearArray"
                                       :townSelected="town" :postalCodeSelected="postalCode" :initialPostalCode="initialPostalCode"
                                       :onSelected="onSelectedPostalCode"
                                       :disabled="(this.town !== null && this.town !== undefined) ? false : true">

        </NewLocationPostalCodeSelector>
      </b-form-group>
    </b-col>
    <b-col cols="12" v-if="communityShowDefault">
      <b-form-group label-for="address">
        <template slot="label">
          <slot name="address-label"><strong>Dirección</strong></slot>
        </template>
        <b-form-input id="address" type="text" placeholder="Dirección" :value="initialAddress" @input="updateAddress">
        </b-form-input>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import NewLocationCommunitySelector from './NewLocationCommunitySelector';
import NewLocationProvinceSelector from './NewLocationProvinceSelector';
import NewLocationTownSelector from './NewLocationTownSelector';
import NewLocationPostalCodeSelector from './NewLocationPostalCodeSelector';

export default {
  name: "AddressContactForm",
  components: {
    NewLocationCommunitySelector,
    NewLocationProvinceSelector,
    NewLocationTownSelector,
    NewLocationPostalCodeSelector
  },
  props: {
    inputSize: String,
    initialCommunity: String,
    communityRequired: Boolean,
    communityShow: Boolean,
    initialProvince: String,
    provinceRequired: Boolean,
    townRequired: Boolean,
    postalCodeRequired: Boolean,
    initialTown: String,
    initialPostalCode: Number,
    initialAddress: String
  },

  data: function () {
    return {
      communityShowDefault: !this.communityShow ? true : false,
      inputSizeDefault: !!this.inputSize ? this.inputSize : '12',
      community: null,
      province: null,
      town: null,
      postalCode: null,
      address: this.initialAddress,
      fieldClearArray: []
    }
  },

  methods: {
    onSelectedCommunity(community) {
      this.province = null;
      this.town = null;
      this.postalCode = null;
      this.community = community;
    },
    onSelectedProvince(province) {

      this.province = province;
    },
    onSelectedTown(town) {
      this.town = town;
    },
    onSelectedPostalCode(postalCode) {
      this.postalCode = postalCode;
    },
    onFieldClear(value) {
      this.fieldClearArray = value;
    },
    updateAddress(value) {
      this.address = value;
      this.$emit('address-change', this.address);
    }
  },
  watch: {

    'community.name': function () {
      this.$emit('community-change', !!this.community ? this.community.name : null);
    },

    'province.name': function () {
      this.$emit('province-change', !!this.province ? this.province.name : null);
    },

    'town.name': function () {
      this.$emit('town-change', !!this.town ? this.town.name : null);
    },

    'postalCode.code': function () {
      this.$emit('postal-code-change', !!this.postalCode ? this.postalCode.code : null);
    },

    address: function () {
      this.$emit('address-change', this.address);
    }
  }
}
</script>

<style scoped>
</style>
